import { BaseModel } from "sjs-base-model";
import InfoUtentePreventivoModel from "./InfoUtentePreventivoModel";
import PianoAmmortamentoModel from "./PianoAmmortamentoModel";

export default class PreventivoModel extends BaseModel {
    public readonly idPreventivo: number = 0;
    public readonly importoInteressi: number = 0;
    public readonly speseIstruttoria: number = 0;
    public readonly impostaBollo: number = 0;
    public readonly tan: number = 0;
    public readonly taeg: number = 0;
    public readonly teg: number = 0;
    public readonly montante: number = 0;
    public readonly costiIntermediazione: number = 0;
    public readonly isPrincipale: boolean = false;
    public readonly rataReimpostata: boolean = false;
    public readonly dataScadenza: string = "";
    public readonly importoRichiesto: number = 0;
    public readonly codiceTipoRichiedente: string = "";
    public readonly dataNascita: string = "";
    public readonly dataAssunzione: string = "";
    public readonly importoNettoRedditoMensile: number = 0;
    public readonly importoRata: number = 0;
    public readonly durata: number = 0;
    public readonly pianoAmmortamento: PianoAmmortamentoModel = new PianoAmmortamentoModel({});
    public readonly codiceAgente: string = "";
    public readonly categoriaAmministrativa: string = "";
    public readonly amministrazione: string = "";
    public readonly canale: string = "";
    public readonly segmento: string = "";
    public readonly prodotto: string = "";
    public readonly percentTassoMontante: number = 0;
    public readonly commissioniPratica: number = 0;
    public readonly totaleVociCostoTan: number = 0;
    public readonly idUtente: number = 0;
    public readonly informazioniUtente: InfoUtentePreventivoModel = new InfoUtentePreventivoModel({});
    public readonly idTipoRichiesta: number = 0;
    public readonly disclaimer: string = "";
    /*
     * Client-Side properties (Not from API)
     */
    // public noneApiProperties: unknown = null;
    constructor(data: Partial<PreventivoModel>) {
        super();

        this.update(data);
    }
}
